import { render } from "./ProjectNavigation.vue?vue&type=template&id=945e6c24"
import script from "./ProjectNavigation.vue?vue&type=script&lang=js"
export * from "./ProjectNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__